

$(document).ready(function () {
    
    var initMenuOverrides = function () {

        var $navbarToggler = $('button.navbar-toggler');
        var $navbar = $($navbarToggler.attr('data-target'));

        // When toggling menu (normally mobile menu), lookup active items
        // and add trigger 'show' in order to expand dropdown menus (if any)
        $navbarToggler.on('click.furillo', function (e) {

            // When desktop or when closing there's no need to run this
            if (!$navbarToggler.is(':visible') || $(this).attr('aria-expanded') === 'true') {
                return;
            }

            $('.nav-item.dropdown.active', $navbar).each(function () {
                $('.collapse', $(this)).first().collapse('show');
            });
        });

        // Since we use BS 'collapse' rather than 'dropdown' for menu we need
        // to add this to close all open collapses when clicking outside of the menu.
        $(document).on('click.furillo', function (e) {

            // If on mobile or still within the navbar, no need to run this
            if ($navbarToggler.is(':visible') || $(e.target).parents('.navbar').length > 0)
                return;

            $('.nav-item .collapse.show').collapse('hide');
        });


        var timeoutId = null;
        $navbar.on('mouseover.furillo', '.nav-item.dropdown', function (e) {

            // If on mobile there's no need to run this
            if ($navbarToggler.is(':visible'))
                return;

            var $this = $(this);

            // If already open (like the parent), no need to run
            if ($('.collapse.show', $this).first().length > 0) {
                return;
            }

            if (timeoutId !== null) {
                clearTimeout(timeoutId);
            }

            timeoutId = setTimeout(function () {
                $('.collapse', $this).first().collapse('show');

                // Always only one open
                $this.siblings('.nav-item.dropdown').each(function () {
                    $('.collapse.show', this).first().collapse('hide');
                });

                timeoutId = null;
            }, 250);
        });

        $navbar.on('mouseleave.furillo', '.nav-item.dropdown', function (e) {

            // If on mobile there's no need to run this
            if ($navbarToggler.is(':visible'))
                return;

            $('.collapse.show', this).first().collapse('hide');
        });
    };

    initMenuOverrides();

    $(document).on('click', '[data-toggle="lightbox"]', function (e) {
        e.preventDefault();
        $(this).ekkoLightbox({
            showArrows: true
        });
    });

    $(document).on('click', '.cookies-close', function () {
        var $moduleBody = $(this).parent();
        $moduleBody.addClass('pressed');
        var $moduleBodyHeight = $moduleBody.outerHeight();
        $moduleBody.css('margin-top', -$moduleBodyHeight);

        setTimeout(function () {
            var days = 30;
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));

            var expires = date.toGMTString();
            document.cookie = 'accepted_cookies=true; expires=' + expires + '; path=/';
        }, 260);
    });

    $('.tag-filters').tagfilter();
    $('body').noreferrer();
});